/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Describes mode for displaying values in the data legend.
 */
export var DataLegendValueMode = /*@__PURE__*/ (function (DataLegendValueMode) {
    /**
     * Specifies automatic mode that resolves to best value display mode
     */
    DataLegendValueMode[DataLegendValueMode["Auto"] = 0] = "Auto";
    /**
     * Specifies values as decimal number, e.g. 170.25 for 170.25
     */
    DataLegendValueMode[DataLegendValueMode["Decimal"] = 1] = "Decimal";
    /**
     * Specifies values with currency symbol, e.g. $170.25 for 170.25
     * Note symbol of the currency depends on the ValueFormatCulture property
     */
    DataLegendValueMode[DataLegendValueMode["Currency"] = 2] = "Currency";
    return DataLegendValueMode;
})({});
/**
 * @hidden
 */
export var DataLegendValueMode_$type = /*@__PURE__*/ markEnum('DataLegendValueMode', 'Auto,0|Decimal,1|Currency,2');
